<script lang="ts" setup>
import { useEnergyBoxUrl } from "@/use/common";

const url = useEnergyBoxUrl();
</script>
<template>
  <img
    :src="url"
    alt=""
    class="icon-base img-render-nearest"
    crossorigin="anonymous"
  />
</template>
